// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"444a031d","598":"10961e04","703":"e9ce490e"}[chunkId] + ".chunk.js";
};